import React from 'react';
import { useTranslation } from 'react-i18next';

import { CurrencyModal } from '../styles/components';
import {
  ModalContentWrapper,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalTitle
} from 'shared/blocks/selfcare/subscription-tunnel/shared/styles/components';
import ChoicesList from 'shared/blocks/selfcare/subscription-tunnel/shared/components/ChoicesList';

interface CurrencyChoiceModalProps {
  currencies: string[];
  onValidateClick: (currencies: { code: string; label: string }[]) => void;
  onCloseClick: () => void;
}

export default function CurrencyChoiceModal({
  currencies,
  onValidateClick,
  onCloseClick
}: CurrencyChoiceModalProps) {
  const { t } = useTranslation();

  const choices = currencies.map(currency => ({
    code: currency,
    label: currency
  }));

  return (
    <CurrencyModal>
      <ModalContentWrapper data-testid="currency-choice-modal">
        <ModalCloseButton onClick={onCloseClick} />

        <ModalHeader>
          <ModalTitle>
            {t(
              'blocks.selfcare.subscriptionPaymentMethods.currencyChoiceModal.title'
            )}
          </ModalTitle>
        </ModalHeader>

        <ModalBody>
          <ChoicesList
            type="unique"
            choices={choices}
            initialChoices={[choices[0]]}
            cancelButtonLabel={t(
              'blocks.selfcare.subscriptionPaymentMethods.currencyChoiceModal.cancel'
            )}
            validateButtonLabel={t(
              'blocks.selfcare.subscriptionPaymentMethods.currencyChoiceModal.validate'
            )}
            onCancelClick={onCloseClick}
            onValidateClick={onValidateClick}
          />
        </ModalBody>
      </ModalContentWrapper>
    </CurrencyModal>
  );
}
